import Vue from 'vue'
import VueI18n from 'vue-i18n'
import pt from './pt/pt'

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'pt',
  fallbackLocale: 'pt',
  messages: {
    pt
  }
})